module.exports = __webpack_public_path__ + "5d0e111283a012eb2d8aea3932f0bfe4.svg";